import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ValidationService } from 'src/app/core/services/validation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorsComponent implements OnInit {
  @Input('control') control!: any;
  @Input('form') form!: any;
  @Input('color') color!: string;

  controlName: string | null = null;

  emailRegex = this.validation.emailPattern;
  alphaRegex = this.validation.alphaPattern;
  numericalRegex = this.validation.numerical;
  decimalRegex = this.validation.decimalPattern;
  percentageRegex = this.validation.percentage;
  floatRegex = this.validation.float;

  passwordRegex = this.validation.passwordPattern;
  webSiteRegex = this.validation.webSiteValidation;
  phoneRegex = this.validation.phonePattern;
  URlRegex = this.validation.urlPattern;
  phoneUSRegex = this.validation.validPhoneUS;
  faxRegex = this.validation.validFax;
  subdomainPattern = this.validation.subdomainPattern;

  passwordLettersPattern = this.validation.passwordLettersPattern;
  passwordNumbersPattern = this.validation.passwordNumbersPattern;
  passwordSpecialCharPattern = this.validation.passwordSpecialCharPattern;

  HexColorPattern = this.validation.HexColorPattern;
  hexColor = this.validation.hexadecimalColor;

  constructor(
    private validation: ValidationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.controlName = this.resolveControlName(this.control);
    if (!this.control) {
      return;
    }

    merge(this.control.valueChanges, this.control.statusChanges)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.cdr.markForCheck();
      });
  }

  private resolveControlName(c: any): string | null {
    const formGroup = c.parent?.controls as Record<string, any> | undefined;
    if (!formGroup) {
      return null;
    }

    return Object.keys(formGroup).find((name) => c === formGroup[name]) || null;
  }
}
